import { render, staticRenderFns } from "./not-support.vue?vue&type=template&id=0401997c&scoped=true"
import script from "./not-support.vue?vue&type=script&lang=js"
export * from "./not-support.vue?vue&type=script&lang=js"
import style0 from "./not-support.vue?vue&type=style&index=0&id=0401997c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0401997c",
  null
  
)

export default component.exports